import React from 'react'
import { Col, Row } from 'react-bootstrap'

import Visibility from "../../../images/icons/visibility.png"
import Book from "../../../images/icons/book.png"

const StatsGa = () => {
    return <div className="stats-ga pt-3 mb-3 border-top">
        <Row>
            <Col sm="9" xs={12}>
                <div className="d-flex visibility-container">
                    <div className="d-flex align-items-center visibility ">
                        <img className="stats-ga-icon" src={Visibility} alt="" />
                        <span className="ml-2">Views: 512</span>
                    </div>
                    <div className="ml-4 ">
                        <img className="stats-ga-icon" src={Book} alt="" />
                        <span className="ml-2">Current Reader: 56</span>
                    </div>
                </div>
            </Col>
            <Col sm="3" xs={12} className="text-sm-right text-left mt-2 mt-sm-0" >
                <span>2 min read</span>
            </Col>
        </Row>
    </div>
}

export default StatsGa